import { LuChevronDown, LuCheck } from 'react-icons/lu';
import { ImageWithFallback } from './figma/image-with-fallback';
import { motion } from "framer-motion";

export function PickupExperienceSection() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <section className="h-screen snap-start flex flex-col bg-white px-5 py-12">
      <motion.div
        className="flex-1 flex flex-col items-center justify-center max-w-2xl mx-auto w-full"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false }}
      >
        <motion.h1
          variants={itemVariants}
          className="text-center mb-8"
          style={{ fontSize: '2.25rem', fontWeight: 800, lineHeight: 1.3 }}
        >
          배달이 아닌<br />
          '직접 픽업' 방식
        </motion.h1>
        
        <motion.div
          variants={itemVariants}
          className="w-full bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl overflow-hidden shadow-xl mb-6"
        >
          <div className="relative w-full h-48">
            <ImageWithFallback
              src="https://images.unsplash.com/photo-1746487836310-ab4bb05e17b8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxmb29kJTIwcGlja3VwJTIwcmVzdGF1cmFudHxlbnwxfHx8fDE3NjU5Njg3OTF8MA&ixlib=rb-4.1.0&q=80&w=1080"
              alt="픽업"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 to-transparent" />
          </div>
          
          <div className="p-8 pt-5 space-y-4">
            <p className="text-white/90 mb-4 text-center" style={{ fontSize: '1.125rem', fontWeight: 600 }}>
              고객이 직접 방문해
            </p>
            <div className="flex items-start gap-4 bg-white/20 backdrop-blur-sm rounded-2xl p-5">
              <LuCheck className="w-6 h-6 text-white flex-shrink-0 mt-1" />
              <p className="text-white" style={{ fontSize: '1.125rem', fontWeight: 700, lineHeight: 1.5 }}>
                매장 분위기를 느끼고
              </p>
            </div>
            
            <div className="flex items-start gap-4 bg-white/20 backdrop-blur-sm rounded-2xl p-5">
              <LuCheck className="w-6 h-6 text-white flex-shrink-0 mt-1" />
              <p className="text-white" style={{ fontSize: '1.125rem', fontWeight: 700, lineHeight: 1.5 }}>
                위치를 기억하고
              </p>
            </div>
            
            <div className="flex items-start gap-4 bg-white/20 backdrop-blur-sm rounded-2xl p-5">
              <LuCheck className="w-6 h-6 text-white flex-shrink-0 mt-1" />
              <p className="text-white" style={{ fontSize: '1.125rem', fontWeight: 700, lineHeight: 1.5 }}>
                다음 방문으로 이어져요
              </p>
            </div>
          </div>
        </motion.div>
        
        <motion.div variants={itemVariants}>
          <LuChevronDown className="w-6 h-6 text-gray-400 animate-bounce" />
        </motion.div>
      </motion.div>
    </section>
  );
}
